import { StyleSheet, View } from "react-native";
import { useSpring, animated } from "react-spring";

import Text from "./text";

const AnimatedView = animated(View);

const CartBadge = ({ count }) => {
  const st = useSpring({
    ...styles.badgeContainer,
    transform: count > 0 ? "scale(1)" : "scale(0)",
    opacity: count > 0 ? 1 : 0,
    config: { tension: 300, friction: 20 },
    
  });

  return (
    <AnimatedView style={st}>
      <Text
        style={[
          styles.badgeText,
          {
            lineHeight: count < 10 ? 17 : 19,
            fontSize: count < 10 ? 13 : 9,
          },
        ]}
      >
        {count || 1}
      </Text>
    </AnimatedView>
  );
};

const styles = StyleSheet.create({
  badgeContainer: {
    position: "absolute",
    top: 5,
    right: 20,
    backgroundColor: "rgb(255, 59, 48)",
    borderRadius: 10,
    height: 20,
    width: 20,
    alignItems: "center",
    justifyContent: "center",
  },
  badgeText: {
    color: "white",
    fontSize: 12,
    marginBottom: 2,
  },
});

export default CartBadge;
